export default __webpack_public_path__ + "dist/media/update-message.48f25f00.svg";